import './App.css';
import {PureComponent} from "react";
import axios from "axios";

const NBSP = String.fromCodePoint(160);
const setProperty = (cssVar, value) => document.documentElement.style.setProperty(cssVar,value)
const setPropertyPx = (cssVar, value) => setProperty(cssVar,value+"px");
const appendSizeThresholds = (config) => {
    const {rows, columns, sizes} = config
    const {bottom, top} = rows
    const {left, right} = columns

    const widths = []
    const heights = []
    for(const size in sizes) {
        const {grid, gap, back} = sizes[size]
        const imgWidth = (1+right-left)*(grid+gap)+gap
        const imgHeight = (1+top-bottom)*(grid+gap)+gap
        const width = Math.max(imgWidth, back) + 100
        const height = Math.max(imgHeight, back) + 100
        widths.push([width, size])
        heights.push([height, size])
    }

    widths.sort((a,b) => a[0]-b[0])
    heights.sort((a,b) => a[0]-b[0])
    widths[0][0] = 0
    heights[0][0] = 0

    config.widths=widths
    config.heights=heights
    return config
}

const largestSize = (sizes, dimension) => {
    let largest = 0
    for(let i=0;i<sizes.length;i++) {
        if(sizes[i][0]>dimension) {
            return largest
        }
        largest = i
    }
    return largest
}

class App extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            enlarged: null,
            url: "",
        };
    }

    componentDidMount = async () => {
        const response = await axios.get("DATA/CONFIG.JSON")
        this.adaptToSize(appendSizeThresholds(response.data))
        window.addEventListener("resize", this.onResize)
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.onResize)
    }

    onResize = () => {
        this.adaptToSize(this.state)
    }

    adaptToSize = (theState) => {
        const {...newState} = theState
        const {widths, heights, sizes} = newState
        const {innerWidth, innerHeight} = window
        newState.isOpen=true;
        const largest = Math.min(largestSize(widths, innerWidth), largestSize(heights, innerHeight))
        newState.size=widths[largest][1]
        newState.innerWidth = innerWidth
        newState.innerHeight = innerHeight

        const {rows, columns, size} = newState

        const {grid, gap, back, axisFontSize, axisPad} = sizes[size]
        const {bottom, top} = rows
        const {left, right} = columns

        const imgWidth = (1+right-left)*(grid+gap)+gap
        const imgHeight = (1+top-bottom)*(grid+gap)+gap

        setProperty('--columns', 1 + right - left)
        setProperty('--rows', 1 + top - bottom)
        setPropertyPx('--grid', grid)
        setPropertyPx('--gap', gap)
        setPropertyPx('--width', imgWidth)
        setPropertyPx('--height', imgHeight)
        setPropertyPx('--back', back)
        setPropertyPx('--axisFontSize', axisFontSize)
        setPropertyPx('--axisPad', axisPad)

        this.setState(newState)
    }

    clickOnFront = (evt) => {
        const {state} = this
        const {rows, columns, cards, sizes, size} = state
        const {grid, gap} = sizes[size]

        const {left, top} = evt.target.getBoundingClientRect()
        const leftGrid = Math.floor((evt.clientX - left) / (grid + gap))
        const topGrid = Math.floor((evt.clientY - top) / (grid + gap))
        const row = rows.top - topGrid
        console.log(evt.pageX, evt.target.x, grid, gap, leftGrid)
        const column = String.fromCodePoint(columns.left + leftGrid + 64)
        const squareId = column + String(row).padStart(2, '0')
        if(cards[squareId]) {
            this.setState({
                enlarged: squareId,
                url: cards[squareId].url
            })
        } else {
            this.setState({enlarged: null, url: ""})
        }
    }

    clickOnBack = () => {
        this.setState({enlarged: null, url: ""})
    }

    render = () => {
        const {clickOnFront, clickOnBack, state} = this
        if (!state.isOpen) {
            return null
        }

        const {enlarged, rows, columns, url, title, sizes, size} = state
        const {grid, back} = sizes[size]
        const {bottom, top} = rows
        const {left, right} = columns

        let bottomCoordinates = []
        for(let i=left;i<=right;i++) {
            const xLetter = String.fromCodePoint(i + 64)
            const isSelected = enlarged && xLetter === enlarged[0] ? "isSelected" : null
            bottomCoordinates.push(<div className={isSelected} key={xLetter}>{xLetter}</div>)
        }

        let rightCoordinates = []
        for(let i=top;i>=bottom;i--) {
            const yNumber = String(i).padStart(2, '0')
            const isSelected = enlarged && yNumber === enlarged.substring(1) ? "isSelected" : null
            rightCoordinates.push(<div className={isSelected} key={yNumber}>{yNumber}</div>)
        }
        return (
            <div id="App">
                <>
                    <header>{title}</header>
                    <div className={"theWebSide"}><a href={url} target={"theOther"}>{url ? url : NBSP}</a></div>
                    <div id={"allTheChrome"}>
                        <div id={"activeArea"}>
                            <img id={"theFront"} src={"TINY" + grid + "/ALL.WEBP"} onClick={clickOnFront} alt={"Front Side of Supergraphic"}/>
                            <div id={"theBack"}
                                 className={enlarged ? "visible": "hidden"}
                                 onClick={clickOnBack}>{enlarged && <img src={"BACK"+back+"/" + enlarged + ".PNG"}
                                                                         alt={enlarged ? "Rear side of module "+enlarged: ""}
                            />}</div>
                        </div>
                        <div id={"yAxis"}>{rightCoordinates}</div>
                        <div id={"xAxis"}>{bottomCoordinates}</div>
                    </div>
                </>

            </div>
        );
    }
}

export default App;
